import React from "react";
import styles from "../statics/styles/divider-viewer.rtlignore-scss";
const withSafariSvgCaretFixer = (Component) => /* @__PURE__ */ React.createElement("div", { className: styles.svgFixerContainer }, Component, /* @__PURE__ */ React.createElement("div", { className: styles.emptyChar }, " "));
export {
  withSafariSvgCaretFixer
};
//# sourceMappingURL=withSafariSvgCaretFixer.js.map
